<template>
  <div class="incident-details-container">
    <!-- Reason/Failure Title -->
    <div class="incident-reason-section">
      <div class="incident-reason-label">{{ incedent_details.status ? 'Failure reason was :' : 'Failure reason :' }}</div>
      <div class="incident-reason-box">
        <span class="incident-reason-text">{{ incedent_details.reason || (incedent_details.status ? 'Keyword Found' : 'keyword Not Found') }}</span>
      </div>
    </div>

    <!-- Status Cards Row -->
    <div class="status-cards-row">
      <div class="status-card">
        <div class="status-card-label">Status</div>
        <div class="status-card-value" :class="incedent_details.status ? 'status-resolved' : 'status-ongoing'">
          <span class="status-badge">
            <span class="status-dot"></span>
          {{ incedent_details.status ? 'Resolved' : 'Ongoing' }}
          </span>
        </div>
      </div>
      <div class="status-card">
        <div class="status-card-label">Started At</div>
        <div class="status-card-value status-date">{{ changeDateFormate(incedent_details.createdAt) }}</div>
      </div>
      <div class="status-card">
        <div class="status-card-label">Duration</div>
        <div class="status-card-value status-duration">{{ convertMsToHM(incedent_details.duration) }}</div>
      </div>
    </div>

    <!-- HTTP Details UI Start  -->
    <div v-if="incedent_details.mtype == 1" class="detail-content">
      <!-- Request Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-8 pl-0">
            <div class="custom-tab-bar">
              <span :class="['custom-tab', requestTabIndex === 0 ? 'active' : '']" @click="requestTabIndex = 0">URL</span>
              <span :class="['custom-tab', requestTabIndex === 1 ? 'active' : '']" @click="requestTabIndex = 1">Headers</span>
            </div>
          </div>
          <button class="hide-button" @click="showRequestSection = !showRequestSection">
            <img v-if="showRequestSection" src="@/assets/icons/incident-detail-hide-section.svg" alt="Hide" class="hide-show-icon" />
            <img v-else src="@/assets/icons/incident-detail-show-section.svg" alt="Show" class="hide-show-icon" />
            {{ showRequestSection ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div v-if="showRequestSection" class="request-details-container">
          <div v-if="requestTabIndex === 0" class="url-method-box">
            <div class="url-label-box">
                  <span class="url-label">URL:</span>
                  <span class="url-value">{{ incedent_details.detail.reqObj.uri }}</span>
                </div>
            <div class="method-pill-box">
                  <span class="method-label">Method:</span>
              <span class="method-pill"><span class="type-dot"></span> {{ incedent_details.detail.reqObj.method.toUpperCase() }}</span>
            </div>
              </div>
          <div v-if="requestTabIndex === 1">
            <div class="headers-content" v-if="incedent_details.detail && incedent_details.detail.reqObj && incedent_details.detail.reqObj.headers">
                <div v-for="[key, value] of Object.entries(incedent_details.detail.reqObj.headers)" :key="key" class="header-item">
                  <code>{{ key }}: {{ value }}</code>
                </div>
              </div>
            </div>
        </div>
      </div>

      <!-- Response Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-8 pl-0">
            <div class="custom-tab-bar">
              <span :class="['custom-tab', responseTabIndex === 0 ? 'active' : '']" @click="responseTabIndex = 0">Body</span>
              <span :class="['custom-tab', responseTabIndex === 1 ? 'active' : '']" @click="responseTabIndex = 1">Headers</span>
            </div>
          </div>
          <button class="hide-button" @click="showResponseSection = !showResponseSection">
            <img v-if="showResponseSection" src="@/assets/icons/incident-detail-hide-section.svg" alt="Hide" class="hide-show-icon" />
            <img v-else src="@/assets/icons/incident-detail-show-section.svg" alt="Show" class="hide-show-icon" />
            {{ showResponseSection ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div v-if="showResponseSection" class="response-details-container">
          <div v-if="responseTabIndex === 0">
              <div class="body-content">
                <code>{{ (incedent_details.detail && incedent_details.detail.body) || 'empty' }}</code>
              </div>
            </div>
          <div v-if="responseTabIndex === 1">
            <div class="headers-content" v-if="incedent_details.detail && incedent_details.detail.resHeaders">
                <div v-for="[key, value] of Object.entries(incedent_details.detail.resHeaders)" :key="key" class="header-item">
                  <code>{{ key }}: {{ value }}</code>
                </div>
              </div>
            </div>
        </div>
        <div v-if="incedent_details.detail && incedent_details.detail.body" class="download-button-wrapper">
          <b-button size="sm" variant="primary" @click="download('response.txt', incedent_details.detail.body)">
            Download Response Body
          </b-button>
        </div>
      </div>
    </div>
    <!-- HTTP Details UI End  -->

    <!-- Keyword Details UI Start  -->
    <div v-else-if="incedent_details.mtype == 2" class="detail-content">
      <!-- Request Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-8 pl-0">
            <div class="custom-tab-bar">
              <span :class="['custom-tab', requestTabIndex === 0 ? 'active' : '']" @click="requestTabIndex = 0">URL</span>
              <span :class="['custom-tab', requestTabIndex === 1 ? 'active' : '']" @click="requestTabIndex = 1">Headers</span>
            </div>
          </div>
          <button class="hide-button" @click="showRequestSection = !showRequestSection">
            <img v-if="showRequestSection" src="@/assets/icons/incident-detail-hide-section.svg" alt="Hide" class="hide-show-icon" />
            <img v-else src="@/assets/icons/incident-detail-show-section.svg" alt="Show" class="hide-show-icon" />
            {{ showRequestSection ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div v-if="showRequestSection" class="request-details-container">
          <div v-if="requestTabIndex === 0" class="url-method-box">
            <div class="url-label-box">
                  <span class="url-label">URL:</span>
                  <span class="url-value">{{ incedent_details.detail.reqObj.uri }}</span>
                </div>
            <div class="method-pill-box">
                  <span class="method-label">Method:</span>
              <span class="method-pill"><span class="type-dot"></span> {{ incedent_details.detail.reqObj.method.toUpperCase() }}</span>
            </div>
              </div>
          <div v-if="requestTabIndex === 1">
            <div class="headers-content" v-if="incedent_details.detail && incedent_details.detail.reqObj && incedent_details.detail.reqObj.headers">
                <div v-for="[key, value] of Object.entries(incedent_details.detail.reqObj.headers)" :key="key" class="header-item">
                  <code>{{ key }}: {{ value }}</code>
                </div>
              </div>
            </div>
        </div>
      </div>

      <!-- Response Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-8 pl-0">
            <div class="custom-tab-bar">
              <span :class="['custom-tab', responseTabIndex === 0 ? 'active' : '']" @click="responseTabIndex = 0">Body</span>
              <span :class="['custom-tab', responseTabIndex === 1 ? 'active' : '']" @click="responseTabIndex = 1">Headers</span>
            </div>
          </div>
          <button class="hide-button" @click="showResponseSection = !showResponseSection">
            <img v-if="showResponseSection" src="@/assets/icons/incident-detail-hide-section.svg" alt="Hide" class="hide-show-icon" />
            <img v-else src="@/assets/icons/incident-detail-show-section.svg" alt="Show" class="hide-show-icon" />
            {{ showResponseSection ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div v-if="showResponseSection" class="response-details-container">
          <div v-if="responseTabIndex === 0">
              <div class="body-content">
                <code>{{ (incedent_details.detail && incedent_details.detail.body) || 'empty' }}</code>
              </div>
            </div>
          <div v-if="responseTabIndex === 1">
            <div class="headers-content" v-if="incedent_details.detail && incedent_details.detail.resHeaders">
                <div v-for="[key, value] of Object.entries(incedent_details.detail.resHeaders)" :key="key" class="header-item">
                  <code>{{ key }}: {{ value }}</code>
                </div>
              </div>
            </div>
        </div>
        <div v-if="incedent_details.detail && incedent_details.detail.body" class="download-button-wrapper">
          <b-button size="sm" variant="primary" @click="download('response.txt', incedent_details.detail.body)">
            Download Response Body
          </b-button>
        </div>
      </div>

      <!-- Failure Reason Section -->
      <div class="detail-section" v-if="incedent_details.detail && incedent_details.detail.statusCode">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Failure Reason</span>
            </div>
          </div>
        </div>
        <div class="failure-reason-container">
          <div class="failure-reason-box">
            <div class="failure-reason-item">
              <span class="failure-reason-label">Status Code:</span>
              <span class="failure-reason-value">{{ incedent_details.detail.statusCode }}</span>
            </div>
            <div class="failure-reason-item" v-if="incedent_details.detail.statusText">
              <span class="failure-reason-label">Status Text:</span>
              <span class="failure-reason-value">{{ incedent_details.detail.statusText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Keyword Details UI End  -->

    <!-- Ping Details UI Start  -->
    <div v-else-if="incedent_details.mtype == 3" class="detail-content">
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Request</span>
            </div>
          </div>
        </div>
        <div class="request-details-container">
          <div class="url-method-box">
            <div class="url-label-box">
              <span class="url-label">URL:</span>
              <span class="url-value">{{ incedent_details.detail && incedent_details.detail.inputHost }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Ping Details UI End  -->

    <!-- Port Details UI Start  -->
    <div v-else-if="incedent_details.mtype == 4" class="detail-content">
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Request</span>
            </div>
          </div>
        </div>
        <div class="request-details-container">
          <div class="url-method-box">
            <div class="url-label-box">
              <span class="url-label">URL:</span>
              <span class="url-value">{{ incedent_details.detail && incedent_details.detail.port ? incedent_details.detail.host + ':' + incedent_details.detail.port : '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Port Details UI End  -->

    <!-- HeartBeat Details UI Start  -->
    <div v-else-if="incedent_details.mtype == 5" class="detail-content">
      <!-- Request Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Request</span>
            </div>
          </div>
        </div>
        <div class="request-details-container">
          <div class="url-method-box">
            <div class="url-label-box">
              <span class="url-label">URL:</span>
              <span class="url-value">{{ request_uri }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Details Section -->
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Details</span>
            </div>
          </div>
        </div>
        <div class="details-table-container">
          <div class="table-responsive">
            <b-table 
              show-empty 
              stacked="md" 
              :items="hertbeat_log_data" 
              :fields="tablefields"
              class="details-table"
            >
              <template #cell(user_agent)="data">
                {{ data.item.headers['user-agent'] }}
              </template>
              <template #cell(createdAt)="data">
                <span class="text-info">{{ changeDateFormate(data.item.createdAt) }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <!-- HeartBeat Details UI End  -->
    <!-- Other Monitor Types -->
    <div v-else class="detail-content">
      <div class="detail-section">
        <div class="tab-bar-row">
          <div class="tab-bar-tabs col-md-5 pl-0">
            <div class="custom-tab-bar">
              <span class="custom-tab active">Request</span>
            </div>
          </div>
        </div>
        <div class="request-details-container">
          <div class="url-method-box">
            <div class="url-label-box">
              <span class="url-label">URL:</span>
              <span class="url-value">{{ incedent_details.detail && incedent_details.detail.reqUrl }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import moment from "moment";
import Config from "../../services/config";
import DashboardController from "../../services/dashboardController";
import HelperFunction from "../../services/helperFunction"
export default {
  name: "IncedentDetails",
  props: { incedent_details: Object },
  data() {
    return {
      monitor_type_opt: [
        { value: null, text: "Please Select" },
        { value: "1", text: "HTTP(s)" },
        { value: "2", text: "Keyword" },
        { value: "3", text: "Ping" },
        { value: "4", text: "Port" },
        { value: "5", text: "Heartbeat" },
        { value: '6', text:'Page Speed' },
        { value: '7', text:'Page Screenshot' }
      ],
      request_uri:'',
      hertbeat_log_data : [],
      tablefields:[
      { key: "ip", label: "IP", sortable: true },
      { key: "user_agent", label: "UserAgent", sortable: true },
      { key: "createdAt", label: "Last Ping On", sortable: true },
      ],
      requestTabIndex: 0,
      responseTabIndex: 0,
      showRequestSection: true,
      showRequestHeaders: false,
      showResponseSection: true,
      showResponseHeaders: false,
    };
  },
  mounted(){
    if(this.incedent_details.mtype == 5){
        this.request_uri = Config.hertbeatUrl + this.incedent_details.mId
        this.getDetails(this.incedent_details.mId)
    }
  },
  methods: {
    async getDetails(id){
        this.hertbeat_log_data = []
        var response = await DashboardController.keywordLog(id);
        if(response.result){
            this.hertbeat_log_data = response.data
        }
    },
    changeDateFormate(d) {
      return moment(d).format("D/M/YYYY, hh:mm A");
    },
    convertMsToHM(millis) {
      return HelperFunction.convertMsToHM(millis)
    },
    download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    },
    linkClass(idx, currentTabIndex) {
      if (currentTabIndex === idx) {
        return ['bg-primary', 'text-white']
      } else {
        return ['bg-light', 'text-dark']
      }
    },
    toggleRequestHeaders() {
      this.showRequestHeaders = !this.showRequestHeaders;
    },
    toggleResponseHeaders() {
      this.showResponseHeaders = !this.showResponseHeaders;
    }
  },
  computed: {
    monitorTypeName() {
      const typeMap = {
        1: 'HTTPs',
        2: 'Keyword',
        3: 'Ping',
        4: 'Port',
        5: 'Heartbeat',
        6: 'Page Speed',
        7: 'Page Screenshot'
      };
      return typeMap[this.incedent_details.mtype] || 'Unknown';
    }
  },
};
</script>



<style scoped>
/* Main Container */
.incident-details-container {
  padding: 24px;
  font-family: 'Poppins', sans-serif;
}

/* Incident Modal Header */
.incident-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
  margin-top: 8px;
}
.incident-header-icon {
  width: 24px;
  height: 24px;
}
.incident-header-title {
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #161616;
}
.incident-header-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: #E8EEFD;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 400;
  color: #344054;
}
.incident-header-type-badge .type-dot {
  width: 8px;
  height: 8px;
  background: #000000;
  border-radius: 50%;
}
.incident-header-divider {
  border-bottom: 1px solid #E5E7EB;
  margin: 8px 0 18px 0;
}

/* Reason/Failure Section */
.incident-reason-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: #FFFFFF;
  border: 2px solid #D2E3FB;
  border-radius: 16px;
  padding: 15px;
  margin-bottom: 24px;
}
.incident-reason-label {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #3A3A3A;
  white-space: nowrap;
}
.incident-reason-box {
  display: inline-flex;
  align-items: center;
  background: rgba(0, 98, 204, 0.1);
  border-radius: 12px;
  padding: 8px 15px;
  margin-left: auto;
}
.incident-reason-text {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #0062CC;
  text-align: center;
}

/* Status Cards Row */
.status-cards-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-bottom: 24px;
  width: 100%;
  padding-bottom: 24px;
  border-bottom: 1px solid #E5E7EB;
}
.status-card {
  background: #FFFFFF;
  border: 2px solid #D2E3FB;
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  min-width: 0;
  box-shadow: none;
  width: 100%;
}
.status-card-label {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}
.status-card-value {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  font-family: 'Poppins', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 16px;
  font-size: 20px;
  font-weight: 500;
  background: rgba(231, 0, 0, 0.1);
  color: #F20707;
}
.status-resolved .status-badge {
  background: rgba(47, 178, 52, 0.1);
  color: #2FB234;
}
.status-badge .status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #F20707;
}
.status-resolved .status-badge .status-dot {
  background: #2FB234;
}
.status-date, .status-duration {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  font-family: 'Poppins', sans-serif;
}

/* Detail Content */
.detail-content {
  margin-top: 32px;
}

.detail-section {
  border-radius: 12px;
  margin-bottom: 32px;
  padding-bottom: 32px;
  overflow: hidden;
  box-shadow: none;
  border-bottom: 1px solid #E5E7EB;
}
.detail-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

/* Custom Tabs */
.custom-tabs >>> .nav-tabs {
  display: flex;
  align-items: center;
  border-bottom: none;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 0;
  position: relative;
  box-shadow: none;
  padding: 0;
}
.custom-tabs >>> .nav-tabs .nav-item {
  flex: 1 1 0;
}
.custom-tabs >>> .nav-tabs .nav-link {
  border: none;
  border-radius: 16px 16px 0 0;
  padding: 18px 40px 16px 40px;
  font-size: 20px;
  font-weight: 700;
  color: #222;
  background: #fff;
  border-bottom: none;
  transition: all 0.2s ease;
  text-align: left;
  box-shadow: none;
}
.custom-tabs >>> .nav-tabs .nav-link.active {
  color: #fff;
  background: #156FE0;
  border-radius: 16px 16px 0 0;
  font-weight: 700;
  box-shadow: none;
}
.custom-tabs >>> .tab-content {
  padding: 0;
  background: #fff;
  border-radius: 0 0 16px 16px;
  border-top: none;
}

/* Tab Content */
.tab-content-wrapper {
  padding: 20px 24px;
  background: white;
  min-height: 120px;
  position: relative;
}

.url-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 24px;
  gap: 24px;
}

.url-text {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.url-label {
  font-weight: 700;
  color: #161616;
  font-size: 22px;
  font-family: 'Poppins', sans-serif;
}

.url-value {
  color: #161616;
  font-size: 22px;
  font-family: 'Poppins', sans-serif;
  word-break: break-all;
}

.method-badge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.method-label {
  font-weight: 700;
  color: #161616;
  font-size: 20px;
  font-family: 'Poppins', sans-serif;
}

.method-value {
  background: #10B981;
  color: white;
  padding: 6px 16px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Hide/Show Button */
.hide-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  background: #fff;
  border: 1px solid #D2E3FB;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #222;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0;
  margin-bottom: 0;
  float: none;
  box-shadow: none;
}
.hide-button:hover {
  background: #F9FAFB;
  border-color: #B6C2D2;
}
.hide-show-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

/* Headers Content */
.headers-content {
  background: #ffffff;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 16px 24px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  clear: both;
}

/* Fix for border radius with scrollbar in headers */
.headers-content::-webkit-scrollbar {
  width: 8px;
}

.headers-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0 12px 12px 0;
}

.headers-content::-webkit-scrollbar-thumb {
  background: #D2E3FB;
  border-radius: 4px;
}

.headers-content::-webkit-scrollbar-thumb:hover {
  background: #B6C2D2;
}

.header-item {
  margin-bottom: 8px;
  word-break: break-all;
  color: #000000 !important;
}

.header-item code {
  background: transparent;
  color: #000000;
  font-size: 13px;
  padding: 0;
}

/* Body Content */
.body-content {
  background: #ffffff;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 16px 24px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: 'Monaco', 'Menlo', 'Courier New', monospace;
}

/* Fix for border radius with scrollbar */
.body-content::-webkit-scrollbar {
  width: 8px;
}

.body-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0 12px 12px 0;
}

.body-content::-webkit-scrollbar-thumb {
  background: #D2E3FB;
  border-radius: 4px;
}

.body-content::-webkit-scrollbar-thumb:hover {
  background: #B6C2D2;
}

.body-content code {
  background: transparent;
  color: #000000;
  font-size: 14px;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.6;
}

/* Download Button */
.download-button-wrapper {
  padding: 16px 24px 0;
  border-top: 1px solid #E5E7EB;
  margin-top: 20px;
}

.download-button-wrapper .btn {
  background: #0B6CFA;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
}

.download-button-wrapper .btn:hover {
  background: #0A5CE6;
}

/* Details Table Container */
.details-table-container {
  background: #fff;
  padding: 20px 24px;
  border-radius: 12px;
  margin-top: 20px;
}

/* Details Table */
.details-table {
  background: #ffffff;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 0;
}

.details-table >>> thead {
  background: #F9FAFB;
}

.details-table >>> th {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  padding: 12px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.details-table >>> td {
  font-size: 14px;
  color: #374151;
  padding: 12px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.details-table >>> tbody tr:last-child td {
  border-bottom: none;
}

/* Responsive */
@media (max-width: 900px) {
  .status-cards-row {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}

/* Tabs Styling */
.incident-tabs >>> .nav-tabs {
  border-bottom: none;
  background: #F9FAFB;
  border-radius: 12px 12px 0 0;
  margin-bottom: 0;
}
.incident-tabs >>> .nav-tabs .nav-link {
  border: none;
  border-radius: 0;
  padding: 14px 40px;
  font-size: 16px;
  font-weight: 500;
  color: #344054;
  background: transparent;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
}
.incident-tabs >>> .nav-tabs .nav-link.active {
  color: #0B6CFA;
  background: #fff;
  border-bottom: 3px solid #0B6CFA;
  font-weight: 600;
}
.incident-tabs >>> .tab-content {
  padding: 0;
}

/* URL/Method Box - cleaned up duplicate styles */
.url-method-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px !important;
  border: 1px solid #D2E3FB;
  padding: 20px 24px;
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}
.url-label-box {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #161616;
  font-family: 'Poppins', sans-serif;
}
.url-label {
  font-weight: 600;
  color: #344054;
  font-size: 20px;
  font-family: 'Poppins', sans-serif;
}
.url-value {
  color: #344054;
  font-size: 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  word-break: break-all;
}
.method-pill-box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 10px 16px;
}
.method-label {
  font-weight: 600;
  color: #000000;
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
}
.method-pill {
  background: rgba(41, 51, 64, 0.30);
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.method-pill .type-dot {
  width: 8px !important;
  height: 8px !important;
  background: #000000;
  border-radius: 50%;
  display: inline-block;
}

/* Tab bar and Hide/Show button row */
.tab-bar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  padding: 0;
  border-bottom: none;
}
.tab-bar-tabs {
  flex: 1 1 0;
  margin-bottom: 0;
}
.tab-bar-row .hide-button {
  margin-right: 16px;
  margin-top: 0;
  margin-bottom: 0;
  height: 44px;
  background: transparent;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #344054;
}
.tab-bar-row .hide-button:hover {
  background: #F9FAFB;
  border-color: #B6C2D2;
}

/* Request Details Container */
.request-details-container {
  background: #fff;
  padding: 0;
  border-radius: 12px;
  margin-top: 20px;
}

/* Response Details Container */
.response-details-container {
  background: #fff;
  padding: 0;
  border-radius: 12px;
  margin-top: 20px;
}

.custom-tab-bar {
  display: flex;
  align-items: center;
  background: #ebebeb;
  border-radius: 12px;
  overflow: hidden;
}
.custom-tab {
  font-size: 20px;
  font-weight: 500;
  color: #344054;
  padding: 14px 60px;
  cursor: pointer;
  background: #ebebeb;
  outline: none;
  position: relative;
  transition: all 0.2s;
  flex: 1;
  text-align: center;
  border-radius: 12px;
}
.custom-tab.active {
  color: #fff;
  background: #156FE0;
  font-weight: 600;
  border-radius: 12px;
}
.custom-tab:first-child.active {
  border-radius: 12px;
}
.custom-tab:last-child.active {
  border-radius: 12px;
}
</style>